import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen overflow-x-hidden bg-gradient-to-b from-slate-50 to-white pt-20">
      {/* Hero Section */}
      <section className="py-12 bg-gradient-to-r from-ocean-900 via-ocean-800 to-ocean-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Privacy Policy</h1>
            <p className="text-white/80">Last updated: December 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 space-y-8">
            
            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">1. Information We Collect</h2>
              <p className="text-slate-600 leading-relaxed mb-3">
                When you book an adventure or contact us, we collect:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4">
                <li>Name and contact details (email, phone number)</li>
                <li>Payment information (processed securely via Stripe)</li>
                <li>Medical information relevant to diving activities</li>
                <li>Emergency contact details</li>
                <li>Booking preferences and special requirements</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">2. How We Use Your Information</h2>
              <p className="text-slate-600 leading-relaxed mb-3">
                We use your information to:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4">
                <li>Process and manage your bookings</li>
                <li>Communicate about your adventures</li>
                <li>Ensure your safety during activities</li>
                <li>Send newsletters (if subscribed)</li>
                <li>Improve our services</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">3. Data Security</h2>
              <p className="text-slate-600 leading-relaxed">
                We take data security seriously. Payment information is processed through Stripe&apos;s secure platform and is never stored on our servers. Personal information is protected using industry-standard encryption and security measures.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">4. Data Sharing</h2>
              <p className="text-slate-600 leading-relaxed">
                We do not sell your personal information. We may share data with:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-1 ml-4 mt-2">
                <li>Payment processors (Stripe) for transactions</li>
                <li>Emergency services if required for safety</li>
                <li>Legal authorities if required by law</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">5. Your Rights</h2>
              <p className="text-slate-600 leading-relaxed">
                You have the right to access, correct, or delete your personal information. To exercise these rights or ask questions about our privacy practices, please contact us at:
              </p>
              <p className="text-coral-600 font-medium mt-2">divecampadventures@gmail.com</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">6. Cookies</h2>
              <p className="text-slate-600 leading-relaxed">
                Our website uses essential cookies to ensure proper functionality. We do not use tracking cookies for advertising purposes.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-3">7. Changes to This Policy</h2>
              <p className="text-slate-600 leading-relaxed">
                We may update this privacy policy from time to time. Any changes will be posted on this page with an updated revision date.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
